const UpdateVitals = (
    event?: any,
    setVitals?: any,
    setNews?: any,
    setAlarms?: any,
    setPatientInfo? : any
) => {
    try {
        if (JSON.parse(event.data).message.alarms) {
            const data = JSON.parse(event.data);

            const tempAlarms = [];
            for (let i = 0; i < data.message.alarms.length; i++) {
                if (
                    JSON.parse(event.data).message.alarms[i].severity !==
                    "Clear"
                ) {
                    //console.log(data.message);
                    const alarm = {
                        ...JSON.parse(event.data).message.alarms[i],
                        device_id: data.message.device_id,
                    };
                    tempAlarms.push(alarm);
                }
            }
            setAlarms(tempAlarms);
        }
        let ws_data = JSON.parse(event.data).message.parameters;
        let news = JSON.parse(event.data).message["NEWS2"];
        let thresholds = JSON.parse(event.data).message["alarm_status"];
        let patient = JSON.parse(event.data).message["patient"];
        //console.log ("ws_data:", ws_data)

        if (
            typeof ws_data === "object" &&
            ws_data !== null 
        ) {

            const tempIBP1 = ws_data.IBP1_Systole ? {
                systole: ws_data.IBP1_Systole,
                diastole: ws_data.IBP1_Diastole,
                map: ws_data.IBP1_Map,
                active_alarm: ["IBP1_Systole", "IBP1_Diastole", "IBP1_Map"].some(key => ws_data?.[key]?.error_alarm_flag !== "" && ws_data?.[key]?.error_alarm_flag !== "0"),
            } : undefined;

            const tempIBP2 = ws_data.IBP2_Systole ? {
                systole: ws_data.IBP2_Systole,
                diastole: ws_data.IBP2_Diastole,
                map: ws_data.IBP2_Map,
                active_alarm: ["IBP2_Systole", "IBP2_Diastole", "IBP2_Map"].some(key => ws_data?.[key]?.error_alarm_flag !== "" && ws_data?.[key]?.error_alarm_flag !== "0")
            } : undefined;

            const tempNIBP = ws_data.NIBP_Systole ? {
                systole: ws_data.NIBP_Systole,
                diastole: ws_data.NIBP_Diastole,
                map: ws_data.NIBP_Map,
                high: thresholds ? thresholds[2].thresholds.hi : 0,
                low: thresholds ? thresholds[2].thresholds.low : 0,
                active_alarm: ["NIBP_Systole", "NIBP_Diastole", "NIBP_Map"].some(key => ws_data?.[key]?.error_alarm_flag !== "" && ws_data?.[key]?.error_alarm_flag !== "0")
            } : undefined;

            const tempSpo2 = ws_data.SpO2 ? {
                sp: ws_data.SpO2,
                perf: ws_data.Perf,
                high: thresholds ? thresholds[1].thresholds.hi : 0,
                low: thresholds ?  thresholds[1].thresholds.lo : 0,
                active_alarm: !["", "0"].includes (ws_data?.SpO2?.error_alarm_flag),
            } : undefined;


            const tempRR = ws_data.Resp ? {
                rr: ws_data.Resp,
                high: thresholds ? thresholds[0].thresholds.hi : 0,
                low: thresholds ? thresholds[0].thresholds.lo : 0,
                active_alarm: !["", "0"].includes (ws_data?.Resp?.error_alarm_flag),
            } : undefined;

            const tempEtCO2 = ws_data.EtCO2 ? {
                co2: ws_data.EtCO2,
                high: thresholds ? thresholds[0].thresholds.hi : 0,
                low: thresholds ? thresholds[0].thresholds.lo : 0,
                active_alarm: !["", "0"].includes (ws_data?.EtCO2?.error_alarm_flag),
            } : undefined;

            const tempAct = ws_data.Act ? {
                act: ws_data.Act,
                high: thresholds ? thresholds[0].thresholds.hi : 0,
                low: thresholds ? thresholds[0].thresholds.lo : 0,
                active_alarm: !["", "0"].includes (ws_data?.Act?.error_alarm_flag),
                //active_alarm: ws_data?.Act?.error_alarm_flag !== "0"
            } : undefined;

            const t1_alm = ws_data?.Temp1?.error_alarm_flag ? !["", "0"].includes (ws_data?.Temp1?.error_alarm_flag) : false;
            const t2_alm = ws_data?.Temp2?.error_alarm_flag ? !["", "0"].includes (ws_data?.Temp2?.error_alarm_flag) : false;
            const tempT = ws_data.Temp1 ? {
                t1: ws_data.Temp1,
                t2: ws_data.Temp2,
                high: thresholds ? thresholds[4].thresholds.hi : 0,
                low: thresholds ? thresholds[4].thresholds.lo : 0,
                active_alarm: t1_alm || t2_alm,
            } : undefined;

            ws_data.HR.high = thresholds ? thresholds[3].hi : 0;
            ws_data.HR.low = thresholds ? thresholds[3].lo : 0;
            if (!ws_data?.HR?.error_alarm_flag) {
                ws_data.HR.active_alarm = false
            } else {
                ws_data.HR.active_alarm = !["", "0"].includes (ws_data?.HR?.error_alarm_flag);
            }
            
            if (patient && setPatientInfo) {
                setPatientInfo (patient)
            }

            const vital_ret: any = {
                HR: ws_data.HR ? ws_data.HR : undefined,
                SpO2: tempSpo2,
                IBP1: tempIBP1,
                IBP2: tempIBP2,
                NIBP: tempNIBP,
                Resp: tempRR,
                Temp: tempT,
                EtCO2: tempEtCO2,
                Act: tempAct,
                ACVPU:        ws_data.ACVPU,
                RespDistress: ws_data.RespDistress
            };

            if (ws_data.SpO2_SPMET) {
                vital_ret.SpO2_SPMET = ws_data.SpO2_SPMET;
            }

            if (ws_data.SpO2_SPCO) {
                vital_ret.SpO2_SPCO = ws_data.SpO2_SPCO;
            }
            if (setVitals)
                setVitals(vital_ret);

            if (setNews)
                setNews(news);

            return vital_ret
        }
    } catch (e) {
        console.log(e);
    }
    return {
        HR: {}, SpO2: {}, IBP1: {}, IBP2: {}, Resp: {}, Temp: {}, ACVPU: {}, RespDistress: {}
    }
};

export default UpdateVitals;
